"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTask = createTask;
exports.deleteTask = deleteTask;
exports.exportData = exportData;
exports.fetchAllTaskRules = fetchAllTaskRules;
exports.fetchCategories = fetchCategories;
exports.fetchExBonusType = fetchExBonusType;
exports.fetchProducts = fetchProducts;
exports.fetchTaskRuleList = fetchTaskRuleList;
exports.getBonusTypes = getBonusTypes;
exports.getTaskDetail = getTaskDetail;
exports.getTaskList = getTaskList;
exports.getUserTaskStatusList = getUserTaskStatusList;
exports.optStatus = optStatus;
exports.pageErr = pageErr;
exports.toggleTaskStatus = toggleTaskStatus;
exports.updateTask = updateTask;
exports.updateTaskRule = updateTaskRule;
exports.uploadImg = uploadImg;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getTaskList(params) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskConfig/page',
    method: 'get',
    params: params
  });
}

// 删除任务配置
function deleteTask(id) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskConfig',
    // 注意是否需要加 /api 前缀
    method: 'delete',
    params: {
      id: id
    } // 参数放在 URL query 中
  });
}
function toggleTaskStatus(id, status) {
  return (0, _requestPIM.default)({
    url: "/xyUserTaskConfig/".concat(id, "/status"),
    method: 'put',
    data: {
      status: status
    }
  });
}
function createTask(data) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskConfig/save',
    method: 'post',
    data: data
  });
}
function updateTask(data) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskConfig/update',
    method: 'put',
    data: data
  });
}
function getBonusTypes(params) {
  return (0, _requestPIM.default)({
    url: '/xyCouponType/pageList',
    method: 'get',
    params: params // 将分页和查询条件作为参数发送
  });
}
// 上传图片返回路径（用于新建，编辑）
function uploadImg(params) {
  return (0, _requestPIM.default)({
    url: '/upload/upload',
    method: 'post',
    data: params
  });
}
function getTaskDetail(id) {
  return (0, _requestPIM.default)({
    url: "/xyUserTaskConfig/".concat(id),
    method: 'get'
  });
}
// 获取指定 ID 的 ExBonusType 数据
function fetchExBonusType(typeId) {
  return (0, _requestPIM.default)({
    url: "/exBonusType/".concat(typeId),
    method: 'get'
  });
}
// 获取全部任务规则（不分页）
function fetchAllTaskRules() {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskRule/listAll',
    method: 'get'
  });
}
//商品分页
function fetchProducts(params) {
  return (0, _requestPIM.default)({
    url: '/exGoods/page',
    method: 'get',
    params: params // 将分页和查询条件作为参数发送
  });
}
//分类分页
function fetchCategories(params) {
  return (0, _requestPIM.default)({
    url: '/exCategory/page',
    method: 'get',
    params: params // 将分页和查询条件作为参数发送
  });
}
function fetchTaskRuleList(params) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskRule/page',
    method: 'get',
    params: params
  });
}
function updateTaskRule(data) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskRule/update',
    method: 'put',
    data: data
  });
}
function getUserTaskStatusList(params) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskStatus/page',
    method: 'get',
    params: params // 将分页和查询条件作为参数发送
  });
}
function exportData(params) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskStatus/exportList',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}
function pageErr(params) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskStatus/pageErr',
    method: 'get',
    params: params // 将分页和查询条件作为参数发送
  });
}
function optStatus(data) {
  return (0, _requestPIM.default)({
    url: '/xyUserTaskStatus/updateStatus',
    method: 'put',
    data: data
  });
}